import store from '../store/store';
/**
 * Returns the calendar mailbox configuration object which is observable
 */
export default function getCalendarConfiguration() {
    return store.calendarConfiguration;
}
//# sourceMappingURL=getCalendarConfiguration.js.map